// Copyright 2026 FlairCV Contributors
// SPDX-License-Identifier: AGPL-3.0-or-later

import { Menu } from 'lucide-react';
import { createContext, useContext } from 'react';

interface SidebarContextValue {
  mobileSidebarOpen: boolean;
  toggleMobileSidebar: () => void;
}

const SidebarContext = createContext<SidebarContextValue | null>(null);

export const SidebarProvider = SidebarContext.Provider;

/** Returns null when rendered outside the authenticated app layout. */
export function useSidebarContext() {
  return useContext(SidebarContext);
}

/**
 * Burger button that opens the mobile sidebar. Renders nothing on
 * desktop — the sidebar is always visible there.
 */
export function SidebarToggle() {
  const ctx = useSidebarContext();
  if (!ctx) return null;

  return (
    <button
      onClick={ctx.toggleMobileSidebar}
      className="-ml-1 shrink-0 rounded-lg p-2 text-muted-foreground transition-colors hover:bg-accent hover:text-foreground lg:hidden"
      aria-label="Open menu"
      aria-expanded={ctx.mobileSidebarOpen}
    >
      <Menu className="h-5 w-5" />
    </button>
  );
}
